import { defineComponent as _defineComponent } from 'vue';
import { BFormInput } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SlugInput',
    props: {
        slug: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        // eslint-disable-next-line vue/no-setup-props-destructure
        const initialSlug = props.slug;
        function onChange(value) {
            const slugFormatted = value
                .replace(/\s+/g, "-")
                .replace(/[/:?#]/g, "")
                .toLowerCase();
            emit("change", slugFormatted);
        }
        function onCancel() {
            emit("change", initialSlug);
        }
        return { __sfc: true, props, emit, initialSlug, onChange, onCancel, BFormInput };
    }
});
